<template>
  <v-container grid-list-md>
    <v-layout wrap align-center>
      <v-flex d-flex>
        <h3 class="primary-color text-center">Resumo do Projeto</h3>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm3>
        <v-img :src="getImagemProduto"></v-img>
      </v-flex>
      <v-flex xs12 sm9 v-if="selectedProduct">
        <h4 class="topic">Dados do gerador</h4>
        <h3 class="primary-text">{{ selectedProduct.PRD_DESCRICAO }}</h3>
        <h5 class="generator-description">{{ selectedProduct.description }}</h5>
        <div
          class="general-information"
          v-html="selectedProduct.DescricaoTecnica"
        ></div>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-start>
      <v-flex xs12 sm6>
        <v-card class="grey lighten-4" flat>
          <v-card-title>
            <h4 class="topic">Dados do cliente</h4>
          </v-card-title>
          <v-card-text>
            <v-layout wrap row>
              <v-flex xs12>
                <p class="client-data-topics grey--text text--darken-2">
                  <b>Informações do cliente</b>
                </p>
              </v-flex>
              <v-divider class="grey lighten-4"></v-divider>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Nome</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.cliente.nome }}</b>
                </p>
              </v-flex>
              <v-flex xs12 sm6>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">E-mail</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.cliente.email }}</b>
                </p>
              </v-flex>
              <v-flex xs12 sm6>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Telefone 1</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.cliente.telefone1 }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Telefone 2</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.cliente.telefone2 }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Estado</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.cliente.estado }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Cidade</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.cliente.cidade }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-4"></v-divider>
              </v-flex>
            </v-layout>
            <v-layout wrap row>
              <v-flex xs12>
                <p class="client-data-topics grey--text text--darken-2">
                  <b>Configurações do gerador</b>
                </p>
              </v-flex>
              <v-divider class="grey lighten-4"></v-divider>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Cobertura desejada</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.filtros.cobertura }}%</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Estrutura desejada</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{
                    estruturas.find(
                      (element) => element.Id === projeto.filtros.estrutura
                    ).Valor
                  }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Família</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{
                    familias.find(
                      (element) => element.Id === projeto.filtros.familia
                    ).Valor
                  }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Tensão</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{
                    tensoes.find(
                      (element) => element.Id === projeto.filtros.tensao
                    ).Valor
                  }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-4"></v-divider>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card class="grey lighten-4" flat>
          <v-card-title>
            <h4 class="topic">Características básicas do gerador</h4>
          </v-card-title>
          <v-card-text>
            <v-layout column>
              <v-flex d-flex>
                <v-card flat class="card-background-color py-2">
                  <v-layout column>
                    <v-flex d-flex>
                      <v-img
                        class="center pl-3"
                        :src="thunderImage"
                        aspect-ratio="1"
                        height="4rem"
                        contain
                      ></v-img>
                      <p class="text-center my-auto card-value">
                        {{
                          parseFloat(
                            caracteristicasBasicas.generatorCapacity
                          ).toFixed(2)
                        }}
                        kwP
                      </p>
                      <p class="text-center my-auto card-info">
                        Potência mínima
                      </p>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex d-flex>
                <v-card flat class="card-background-color py-2">
                  <v-layout column>
                    <v-flex d-flex>
                      <v-img
                        class="center pl-3"
                        :src="areaImage"
                        aspect-ratio="1"
                        height="4rem"
                        contain
                      ></v-img>
                      <p class="text-center my-auto card-value">
                        {{
                          parseFloat(caracteristicasBasicas.area).toFixed(2)
                        }}m²
                      </p>
                      <p class="text-center my-auto card-info">
                        Área mínima<br />
                        ocupada pelo sistema
                      </p>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex d-flex>
                <v-card flat class="py-2 card-background-color">
                  <v-layout column>
                    <v-flex d-flex>
                      <v-img
                        class="center pl-3"
                        :src="weightImage"
                        aspect-ratio="1"
                        height="4rem"
                        contain
                      ></v-img>
                      <p class="text-center my-auto card-value">
                        {{
                          parseFloat(caracteristicasBasicas.weight).toFixed(2)
                        }}Kg
                      </p>
                      <p class="text-center my-auto card-info">
                        Peso sobre o telhado
                      </p>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="grey lighten-4 mt-3" flat>
          <v-card-title>
            <h4 class="topic">Dados comerciais</h4>
          </v-card-title>
          <v-card-text>
            <v-layout wrap row>
              <v-divider class="grey lighten-4"></v-divider>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Pagamento</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ modoPagamento[projeto.modoPagamento] }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex
                xs12
                sm6
                v-if="projeto.cliente.parcelaSelecionada.quantidade != null"
              >
                <p class="grey--text text--darken-2">Parcela</p>
              </v-flex>
              <v-flex
                xs12
                sm6
                v-if="projeto.cliente.parcelaSelecionada.quantidade != null"
              >
                <p class="grey--text text--darken-2">
                  <b>{{
                    parcelas.filter((c) => c.code == projeto.cliente.parcela)[0]
                      .label
                  }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex
                xs12
                sm6
                v-if="projeto.cliente.parcelaSelecionada.quantidade != null"
              >
                <p class="grey--text text--darken-2">Valor da parcela</p>
              </v-flex>
              <v-flex
                xs12
                sm6
                v-if="projeto.cliente.parcelaSelecionada.quantidade != null"
              >
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.cliente.parcelaSelecionada.label }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Prazo de entrega</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.prazoEntrega }} dias</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Contato de Revenda</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.contatoRevenda.empresa }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Estado</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.contatoRevenda.estado }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-2"></v-divider>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">Cidade</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="grey--text text--darken-2">
                  <b>{{ projeto.contatoRevenda.cidade }}</b>
                </p>
              </v-flex>
              <v-flex xs12>
                <v-divider class="grey lighten-4"></v-divider>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-card color="#50BED3" dark>
          <v-card-title>
            <v-layout wrap row>
              <v-flex xs12 sm6 d-flex>
                <h3>Valor da cotação</h3>
              </v-flex>
              <v-flex xs12 sm6 d-flex>
                <h2 class="text-xs-left text-sm-right final-value-color">
                  R$ {{ projeto.valorEUP }}
                </h2>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProjectSummary",
  data() {
    return {
      thunderImage: require("./icons/thunder.svg"),
      areaImage: require("./icons/area.svg"),
      weightImage: require("./icons/weight.svg"),
      infoImage: require("./icons/info.svg"),
      modoPagamento: ["À vista", "À prazo"],
    };
  },
  computed: {
    ...mapGetters([
      "projeto",
      "selectedProduct",
      "caracteristicasBasicas",
      "estruturas",
      "tensoes",
      "familias",
      "parcelas",
    ]),
    getImagemProduto() {
      try {
        return this.selectedProduct.Imagens[0].ArqUrlHires;
      } catch (error) {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.final-value-color {
  color: #021746;
}
.client-data-topics {
  font-size: 16px;
}

.card-background-color {
  background-color: #f5f5f5;
}
</style>
